import React from "react";

import IconBase, { IconBaseProps } from "./IconBase";

/**
 * Iron Studies — 20×20 lab group icon (Figma 835:64).
 * Magnifying-glass over a cell, 4 vector layers.
 */
const IconIronStudies: React.FC<IconBaseProps> = ({
  size = 24,
  color = "currentColor",
  className = "",
  ...props
}) => {
  const iconSize =
    typeof size === "number" ? size : parseInt(size as string, 10) || 24;
  return (
    <IconBase
      size={iconSize}
      color={color}
      className={className}
      viewBox="0 0 20 20"
      {...props}
    >
      <g transform="translate(11.25 10.834)">
        <path d="M1.66667 0.833333C1.66667 1.29358 1.29358 1.66667 0.833333 1.66667C0.373083 1.66667 0 1.29358 0 0.833333C0 0.373083 0.373083 0 0.833333 0C1.29358 0 1.66667 0.373083 1.66667 0.833333Z" />
      </g>
      <g transform="translate(9.166 8.75)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.91667 5.83333C4.5275 5.83333 5.83333 4.5275 5.83333 2.91667C5.83333 1.30583 4.5275 0 2.91667 0C1.30583 0 0 1.30583 0 2.91667C0 4.5275 1.30583 5.83333 2.91667 5.83333ZM4.58333 2.91667C4.58333 3.83713 3.83713 4.58333 2.91667 4.58333C1.99621 4.58333 1.25 3.83713 1.25 2.91667C1.25 1.99621 1.99621 1.25 2.91667 1.25C3.83713 1.25 4.58333 1.99621 4.58333 2.91667Z"
        />
      </g>
      <g transform="translate(5.312 11.042)">
        <path d="M0.520833 0C0.233167 0 0 0.233167 0 0.520833V2.08333C0 2.371 0.233167 2.60417 0.520833 2.60417C0.8085 2.60417 1.04167 2.371 1.04167 2.08333V0.520833C1.04167 0.233167 0.8085 0 0.520833 0Z" />
      </g>
      <g transform="translate(1.666 1.666)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.33333 16.6667C12.9357 16.6667 16.6667 12.9357 16.6667 8.33333C16.6667 3.73096 12.9357 0 8.33333 0C3.73096 0 0 3.73096 0 8.33333C0 12.9357 3.73096 16.6667 8.33333 16.6667ZM7.82608 2.60425C7.09879 2.60238 6.40883 2.76242 5.79037 3.05042L6.28162 3.70538C7.16296 3.29304 8.19308 3.18996 9.19896 3.48979C9.41946 3.55554 9.54496 3.78758 9.47921 4.00812C9.4135 4.22867 9.18142 4.35412 8.96087 4.28842C7.22454 3.77083 5.39737 4.75883 4.87975 6.49517C4.81404 6.71571 4.58196 6.84117 4.36142 6.77546C4.14092 6.70971 4.01542 6.47767 4.08117 6.25712C4.34421 5.37471 4.87696 4.64642 5.5625 4.13546L5.06346 3.47008C3.82825 4.33546 3.01908 5.76812 3.01492 7.39092C3.01433 7.62104 2.82733 7.80713 2.59721 7.80654C2.36709 7.80596 2.18102 7.61892 2.1816 7.38883C2.18953 4.27821 4.71763 1.76297 7.82821 1.7709C8.05833 1.77149 8.24442 1.95851 8.24383 2.18863C8.24325 2.41875 8.05621 2.60483 7.82608 2.60425ZM10.4167 13.75C12.4877 13.75 14.1667 12.0711 14.1667 10C14.1667 7.92892 12.4877 6.25 10.4167 6.25C8.34558 6.25 6.66667 7.92892 6.66667 10C6.66667 12.0711 8.34558 13.75 10.4167 13.75ZM5.52083 9.89583V11.4583C5.52083 12.2062 4.91454 12.8125 4.16667 12.8125C3.41879 12.8125 2.8125 12.2062 2.8125 11.4583V9.89583C2.8125 9.14796 3.41879 8.54167 4.16667 8.54167C4.91454 8.54167 5.52083 9.14796 5.52083 9.89583Z"
        />
      </g>
    </IconBase>
  );
};

export default IconIronStudies;
